<template>
  <section>
    <loading-flux :value="loading"></loading-flux>
    <v-dialog
      v-model="modalAction"
      width="90%"
      scrollable
      @keydown="executeCloseModalCreateProjectFromPresale"
      @click:outside="executeCloseModalCreateProjectFromPresale"
    >
      <v-card>
        <div class="p-4 pb-0">
          <h5 class="font">
            {{ onlyRead ? "Información" : projectInfo ? "Modificar" : "Crear" }}
            Proyecto de SAP de Preventa {{ $route.params.codePresale }}
            {{ $route.query.presale_name }}
          </h5>
        </div>
        <hr />
        <v-card-text class="px-0">
          <v-container class="">
            <v-stepper non-linear v-model="stepper" elevation="0">
              <v-stepper-header
                class="mb-2 d-flex justify-space-around elevation-4 rounded"
              >
                <v-stepper-step step="1" editable>
                  Datos del Cliente
                </v-stepper-step>
                <v-stepper-step
                  step="2"
                  @click="
                    !projectInfo ? setNameAndTypeProjectFromTypePresale() : ''
                  "
                  :editable="clientSearchInSap !== null || client !== null"
                >
                  Datos del Proyecto
                </v-stepper-step>
                <v-stepper-step
                  step="3"
                  editable
                  @click="
                    setDocumentsToCompare(documentsContractAndIdentityCard)
                  "
                >
                  Comparar Documentos (Opcional)
                </v-stepper-step>
              </v-stepper-header>

              <v-stepper-items>
                <v-stepper-content class="p-1 px-1" step="1">
                  <v-form @submit.prevent="updateOrCreateClient">
                    <v-row align-content="center" class="mt-2">
                      <v-col cols="12" md="8" sm="12" class="pt-3">
                        <label for="rut" class="mb-0">
                          Selecciona el Tipo de Cliente *
                        </label>
                        <v-radio-group
                          v-model="formClient.type_client"
                          :disabled="onlyRead"
                          row
                          class=""
                        >
                          <v-radio :value="TYPE_CLIENT_PERSON">
                            <template v-slot:label>
                              <span class="mt-1" style="font-size: 15px">
                                Persona Natural
                              </span>
                            </template>
                          </v-radio>
                          <v-radio :value="TYPE_CLIENT_COMPANY">
                            <template v-slot:label>
                              <span class="mt-1" style="font-size: 15px">
                                Empresa
                              </span>
                            </template>
                          </v-radio>
                        </v-radio-group>
                      </v-col>
                      <p
                        v-show="
                          !client &&
                            formClient.type_client == TYPE_CLIENT_COMPANY
                        "
                        class="mb-2 text-primary px-2"
                      >
                        <v-icon class="mx-1" color="primary">
                          mdi-alert-circle-outline
                        </v-icon>
                        <b>Atención: </b> Ingresa el RUT de la empresa para
                        verificar si existe y precargar los datos, si no,
                        ingresa a continuación los datos.
                      </p>
                      <v-col
                        cols="12"
                        md="8"
                        sm="12"
                        class="pt-3"
                        v-if="formClient.type_client == TYPE_CLIENT_COMPANY"
                      >
                        <label for="rut" class="mt-1"> RUT Empresa * </label>
                        <v-text-field
                          placeholder="Ingrese el RUT de la empresa"
                          :disabled="loadingSearchClient || onlyRead"
                          @keypress="validateRutFormat"
                          @paste="
                            validateRutFormat($event);
                            formatRutCompany();
                          "
                          v-model="formClient.rutCompany"
                          :error="
                            $v.formClient.rutCompany.$invalid &&
                              $v.formClient.rutCompany.$model !== null
                          "
                          :error-messages="
                            $v.formClient.rutCompany.$invalid &&
                            $v.formClient.rutCompany.$model
                              ? 'El RUT ingresado no es válido'
                              : null
                          "
                          @input="formatRutCompany"
                        ></v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        md="4"
                        sm="12"
                        class="pt-0"
                        v-if="formClient.type_client == TYPE_CLIENT_COMPANY"
                      >
                        <div v-show="loadingSearchClient" class="mt-5">
                          <v-progress-circular
                            indeterminate
                            color="primary"
                            size="18"
                          ></v-progress-circular>
                          <small>{{
                            onlyRead
                              ? "Cargando información"
                              : "Buscando Empresa..."
                          }}</small>
                        </div>
                        <v-btn
                          v-if="!onlyRead"
                          :disabled="
                            !formClient.rutCompany ||
                              loadingSearchClient ||
                              !validateRut(formClient.rutCompany)
                          "
                          @click="searchClient(formClient.rutCompany)"
                          small
                          color="primary text-white"
                          :class="{
                            'mt-3': loadingSearchClient,
                            'mt-14': !loadingSearchClient,
                          }"
                        >
                          <small> Buscar Empresa </small>
                        </v-btn>
                      </v-col>
                      <p
                        v-show="
                          disabledFormClient &&
                            !client &&
                            formClient.type_client == TYPE_CLIENT_PERSON
                        "
                        class="mb-2 text-primary px-2"
                      >
                        <v-icon class="mx-1" color="primary">
                          mdi-alert-circle-outline
                        </v-icon>
                        <b>Atención: </b> Ingresa el RUT para verificar si
                        existe y precargar los datos, si no, ingresa a
                        continuación los datos.
                      </p>
                      <v-col cols="12" md="8" sm="12" class="pt-3">
                        <label for="rut" class="mt-1"> RUT Persona * </label>
                        <v-text-field
                          placeholder="Ingrese el RUT de la Persona"
                          :disabled="
                            onlyRead ||
                              (loadingSearchClient &&
                                formClient.type_client == TYPE_CLIENT_PERSON)
                          "
                          v-model="formClient.rut"
                          @keypress="validateRutFormat"
                          @paste="validateRutFormat"
                          :error="
                            $v.formClient.rut.$invalid &&
                              $v.formClient.rut.$model !== null
                          "
                          :error-messages="
                            $v.formClient.rut.$invalid &&
                            $v.formClient.rut.$model
                              ? 'El RUT ingresado no es válido'
                              : null
                          "
                          @input="formatRut"
                        ></v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        md="4"
                        sm="12"
                        class="pt-0"
                        v-if="formClient.type_client == TYPE_CLIENT_PERSON"
                      >
                        <div v-show="loadingSearchClient" class="mt-5">
                          <v-progress-circular
                            indeterminate
                            color="primary"
                            size="18"
                          ></v-progress-circular>
                          <small>{{
                            onlyRead
                              ? "Cargando información"
                              : "Buscando Persona..."
                          }}</small>
                        </div>
                        <v-btn
                          v-if="!onlyRead"
                          :disabled="
                            !formClient.rut ||
                              loadingSearchClient ||
                              !validateRut(formClient.rut)
                          "
                          @click="searchClient(formClient.rut)"
                          small
                          color="primary text-white"
                          :class="{
                            'mt-3': loadingSearchClient,
                            'mt-14': !loadingSearchClient,
                          }"
                        >
                          <small> Buscar Persona </small>
                        </v-btn>
                      </v-col>
                      <v-col cols="12" md="6" sm="12" class="pt-0">
                        <label for="name_client"> Nombre del Cliente * </label>
                        <v-text-field
                          :disabled="onlyRead"
                          placeholder="Ingresa el Nombre del Cliente"
                          v-model="$v.formClient.name.$model"
                          :error="$v.formClient.name.$invalid && submitUpload"
                          :error-messages="
                            $v.formClient.name.$invalid && submitUpload
                              ? 'Este campo es requerido'
                              : null
                          "
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="6" sm="12" class="pt-0">
                        <label> Giro del Cliente * </label>
                        <v-autocomplete
                          :disabled="
                            onlyRead ||
                              formClient.type_client == TYPE_CLIENT_PERSON
                          "
                          placeholder="Ingresa el giro del cliente"
                          v-model="$v.formClient.giro.$model"
                          :error="$v.formClient.giro.$invalid && submitUpload"
                          :error-messages="
                            $v.formClient.giro.$invalid && submitUpload
                              ? 'Este campo es requerido'
                              : null
                          "
                          :items="wrappedAllSupplierDrafts"
                          item-text="name"
                          item-value="id"
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols="12" md="6" sm="12" class="pt-0">
                        <label for="contact_user_name">
                          Nombre del Contacto *
                        </label>
                        <v-text-field
                          :disabled="
                            onlyRead ||
                              formClient.type_client == TYPE_CLIENT_PERSON
                          "
                          placeholder="Ingresa el nombre del contacto"
                          v-model="$v.formClient.contact_user_name.$model"
                          :error="
                            $v.formClient.contact_user_name.$invalid &&
                              submitUpload
                          "
                          :error-messages="
                            $v.formClient.contact_user_name.$invalid &&
                            submitUpload
                              ? 'Este campo es requerido'
                              : null
                          "
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="6" sm="12" class="pt-0">
                        <label for="contact_phone">
                          Teléfono del Contacto *
                        </label>
                        <v-text-field
                          v-model="$v.formClient.contact_phone.$model"
                          @keypress="validatePhone"
                          @paste="validatePhone"
                          :disabled="onlyRead"
                          placeholder="Ingresa el teléfono del contacto"
                          :error="
                            $v.formClient.contact_phone.$invalid && submitUpload
                          "
                          :error-messages="
                            $v.formClient.contact_phone.$invalid && submitUpload
                              ? 'Este campo es requerido'
                              : null
                          "
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="6" sm="12" class="pt-0">
                        <label for="contact_user_email">
                          Correo Electrónico del Contacto *
                        </label>
                        <v-text-field
                          :disabled="onlyRead"
                          placeholder="Ingresa el correo del contacto"
                          v-model="$v.formClient.contact_user_email.$model"
                          :error="
                            $v.formClient.contact_user_email.$invalid &&
                              submitUpload
                          "
                          :error-messages="
                            $v.formClient.contact_user_email.$invalid &&
                            submitUpload
                              ? 'Este campo debe ser un correo electrónico válido'
                              : null
                          "
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="6" sm="12" class="pt-0">
                        <label for="commune"> Comuna * </label>
                        <v-autocomplete
                          placeholder="Selecciona la comuna"
                          :disabled="onlyRead"
                          v-model="$v.formClient.commune.$model"
                          :error="
                            $v.formClient.commune.$invalid && submitUpload
                          "
                          :error-messages="
                            $v.formClient.commune.$invalid && submitUpload
                              ? 'Este campo es requerido'
                              : null
                          "
                          :items="communes"
                          item-text="name"
                          item-value="name"
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols="12" md="6" sm="12" class="pt-0">
                        <label for="region"> Región * </label>
                        <v-autocomplete
                          disabled
                          placeholder="Selecciona la región"
                          v-model="$v.formClient.region.$model"
                          :error="$v.formClient.region.$invalid && submitUpload"
                          :error-messages="
                            $v.formClient.region.$invalid && submitUpload
                              ? 'Este campo es requerido'
                              : null
                          "
                          :items="wrappedRegions"
                        ></v-autocomplete>
                      </v-col>

                      <v-col cols="12" md="12" sm="12">
                        <label for="address"> Dirección * </label>
                        <v-textarea
                          rows="2"
                          counter
                          :disabled="onlyRead"
                          placeholder="Ingresa la Dirección del Cliente"
                          v-model="$v.formClient.address.$model"
                          :error="
                            ((formClient.address &&
                              formClient.address.length > 50) ||
                              $v.formClient.address.$invalid) &&
                              submitUpload
                          "
                          :error-messages="
                            formClient.address && formClient.address.length > 50
                              ? 'Ingrese un máximo de 50 caracteres'
                              : $v.formClient.address.$invalid && submitUpload
                              ? 'Este campo es requerido'
                              : null
                          "
                        ></v-textarea>
                        <pre></pre>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-stepper-content>
                <v-stepper-content class="p-1 px-2" step="2">
                  <v-form @submit.prevent="sendLinkPresaleToProject">
                    <v-row align-content="center" class="mt-8">
                      <v-col cols="12" md="12" sm="12" class="pt-0">
                        <label for="name_project">
                          Nombre del Cliente *
                        </label>
                        <v-text-field
                          name="name_project"
                          :disabled="onlyRead"
                          placeholder="Ingresa el Nombre del Cliente"
                          v-model="$v.form.name_project.$model"
                          :error="$v.form.name_project.$invalid && submitUpload"
                          :error-messages="
                            $v.form.name_project.$invalid && submitUpload
                              ? 'Este campo es requerido'
                              : null
                          "
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="12" sm="12" class="pt-0">
                        <label class="mt-1" for="type_sale">
                          Tipo de Contrato *
                        </label>
                        <v-autocomplete
                          v-if="!onlyRead"
                          disabled
                          name="type_sale"
                          placeholder="Selecciona el Tipo de Contrato"
                          v-model="$v.form.type_sale.$model"
                          :error="$v.form.type_sale.$invalid && submitUpload"
                          :error-messages="
                            $v.form.type_sale.$invalid && submitUpload
                              ? 'Este campo es requerido'
                              : null
                          "
                          :items="typeSales"
                          item-text="name"
                          item-value="name"
                        ></v-autocomplete>
                        <p v-else class="mt-0">
                          <br />
                          {{
                            form.type_sale
                              ? form.type_sale
                              : "Sin Tipo de Venta"
                          }}
                        </p>
                      </v-col>
                      <v-col cols="12" md="12" sm="12" class="pt-0">
                        <label class="mt-1" for="type_product">
                          Tipo de Producto *
                        </label>
                        <v-autocomplete
                          v-if="!onlyRead"
                          name="type_product"
                          placeholder="Selecciona el Tipo de Producto"
                          v-model="$v.form.type_product.$model"
                          :error="$v.form.type_product.$invalid && submitUpload"
                          :error-messages="
                            $v.form.type_product.$invalid && submitUpload
                              ? 'Este campo es requerido'
                              : null
                          "
                          :items="wrappedTypeProjectProducts"
                          item-text="name_code"
                          item-value="code"
                        ></v-autocomplete>
                        <p v-else class="mt-0">
                          <br />
                          {{
                            form.type_product
                              ? typeProjectProducts.find(
                                  (item) => item.code == form.type_product,
                                ).name
                              : "Sin Tipo de Producto"
                          }}
                        </p>
                      </v-col>
                      <v-col cols="12" sm="6" class="pt-0">
                        <label for="uf_units">
                          Valor de venta bruto del contrato (UF) *
                        </label>
                        <!--
                          Solo lectura: monto formateado con decimales
                          (ej: 1.234,56 UF)
                        -->
                        <v-text-field
                          v-if="onlyRead"
                          id="uf_units"
                          name="uf_units"
                          type="text"
                          readonly
                          suffix="UF"
                          :value="ufDisplayValue"
                          :error="$v.form.uf_units.$invalid && submitUpload"
                          :error-messages="
                            $v.form.uf_units.$invalid && submitUpload
                              ? ufErrorMessage
                              : null
                          "
                        ></v-text-field>
                        <!--
                          Edición: acepta decimales con punto o coma.
                          type="text" + inputmode="decimal" evita que el
                          navegador descarte la coma decimal (formato chileno),
                          como ocurría con type="number".
                        -->
                        <v-text-field
                          v-else
                          id="uf_units"
                          name="uf_units"
                          type="text"
                          inputmode="decimal"
                          suffix="UF"
                          placeholder="Ingresa el valor de venta bruto del contrato en UF"
                          v-model="$v.form.uf_units.$model"
                          @keypress="onUfKeypress"
                          :error="$v.form.uf_units.$invalid && submitUpload"
                          :error-messages="
                            $v.form.uf_units.$invalid && submitUpload
                              ? ufErrorMessage
                              : null
                          "
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" class="pt-0" v-if="onlyRead || !projectInfo">
                        <label for="csi_allowed" class="ma-0">
                            Cliente posee convenio bancario? (Cuotas sin interés)
                        </label>
                        <v-combobox
                        id="csi_allowed"
                        name="csi_allowed"
                        v-model="$v.form.csi_allowed.$model"
                        :items="csiAllowedOptions"
                        item-text="text"
                        item-value="value"
                        :disabled="onlyRead"
                        placeholder="Selecciona una opción"
                        :error="$v.form.csi_allowed.$invalid && submitUpload"
                        :error-messages="
                          $v.form.csi_allowed.$invalid && submitUpload
                            ? 'Este campo es requerido'
                            : null
                        "
                        @change="onChangeCsiAllowed"
                        >
                        </v-combobox>
                      </v-col>
                      <v-col cols="12" md="12" sm="12" class="pt-0">
                        <label for="contract_date">
                          Fecha del contrato
                        </label>
                        <v-menu
                          ref="menu"
                          name="contract_date"
                          v-model="datepicker_menu_start"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="contract_date_formatted"
                              prepend-icon="mdi-calendar"
                              readonly
                              label="Fecha de contrato"
                              v-bind="attrs"
                              v-on="on"
                              :error="
                                $v.form.contract_date.$invalid && submitUpload
                              "
                              :error-messages="
                                $v.form.contract_date.$invalid && submitUpload
                                  ? 'Este campo es requerido'
                                  : null
                              "
                              clearable
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="form.contract_date"
                            scrollable
                            locale="es"
                            :max="maxContractDate"
                            @input="datepicker_menu_start = false"
                          ></v-date-picker>
                        </v-menu>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-stepper-content>
                <v-stepper-content class="p-1 px-2" step="3">
                  <preview-documents-side-a-side
                    ref="previewDocumentsSideAside"
                    :onlyReadContract="false"
                  ></preview-documents-side-a-side>
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>
          </v-container>
        </v-card-text>
        <v-card-actions class="container">
          <v-spacer></v-spacer>
          <v-btn
            color="red darken-2"
            outlined
            @click="executeCloseModalCreateProjectFromPresale"
          >
            <small> Cerrar </small>
          </v-btn>
          <v-btn
            v-if="!onlyRead && client"
            @click="stepper == 1 ? (stepper += 1) : (stepper -= 1)"
            outlined
            color="primary text-white"
            class="float-right mr-1"
          >
            <small> {{ stepper == 1 ? "Siguiente" : "Volver" }} </small>
          </v-btn>
          <v-btn
            v-if="!onlyRead"
            @click="
              stepper == 1 ? sendAddClient() : sendCreateProjectFromPresale()
            "
            :color="`${client ? 'warning' : 'primary'} text-white`"
            class="float-right mr-1"
          >
            <small>
              {{
                client ? "Modificar" : stepper == 1 ? "Continuar" : "Finalizar"
              }}
            </small>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { authUsuarioComputed } from "@/state/helpers";
import { preventCloseIfNotKeyEventEsc } from "@/helpers/common";
import { required, requiredIf, email, maxLength } from "vuelidate/lib/validators";
import swal2 from "sweetalert2";
import { formatToChileanRut, validateRut, rutValid } from "@/helpers/rut";
import {
  TYPE_CLIENT_COMPANY,
  TYPE_CLIENT_PERSON,
  BUSINESS_CATEGORY_PARTICULAR,
  TYPE_PROJECTS_RESIDENTIAL,
  NAME_FOLDER_SALE_RESIDENTIAL,
  NAME_FILE_CONTRACT,
  NAME_FILE_IDENTITY_CARD,
} from "@/constants/presale";
import { validatePhone } from "@/helpers/common";
import PreviewDocumentsSideASide from "./signContract/PreviewDocumentsSideASide.vue";
import moment from "moment";

// Cantidad de decimales que soporta el monto UF (BD: DECIMAL(20,3))
const UF_MAX_DECIMALS = 3;
// Mínimo de decimales visibles al mostrar el monto
const UF_MIN_DECIMALS = 2;

/**
 * Normaliza lo que se teclea o se recibe en el campo UF.
 * Reglas:
 * - Sólo dígitos y un separador decimal.
 * - "," y "." se aceptan como decimal (formato chileno o neutro).
 * - Con varios separadores del mismo tipo se asumen de miles ("1.234.567").
 * - Con mezcla ("," y ".") el último separador es el decimal ("1.234,56").
 * - Trunca a UF_MAX_DECIMALS decimales.
 * Devuelve el string con punto decimal o null si no hay valor.
 */
function normalizeUfTyping(value) {
  if (value === null || value === undefined) return null;

  let text = String(value).replace(/\s/g, "");
  const hasComma = text.includes(",");
  const hasDot = text.includes(".");
  const commas = (text.match(/,/g) || []).length;
  const dots = (text.match(/\./g) || []).length;

  if (hasComma && hasDot) {
    const lastDecimalIndex = Math.max(text.lastIndexOf("."), text.lastIndexOf(","));
    text = text.replace(/[.,]/g, (separator, offset) =>
      offset === lastDecimalIndex ? "." : "",
    );
  } else if (commas > 1 || dots > 1) {
    text = text.replace(/[.,]/g, "");
  } else {
    text = text.replace(",", ".");
  }

  text = text.replace(/[^\d.]/g, "");
  const [integer, decimals] = text.split(".");
  if (decimals !== undefined && decimals.length > UF_MAX_DECIMALS) {
    text = `${integer}.${decimals.slice(0, UF_MAX_DECIMALS)}`;
  }
  return text;
}

/**
 * Convierte un monto UF (number o string con "," o ".") a número con
 * hasta UF_MAX_DECIMALS decimales. Devuelve null si no es numérico.
 */
function parseUfValue(value) {
  const text = normalizeUfTyping(value);
  if (!text || !/^\d+(\.\d+)?$/.test(text)) return null;

  const amount = Number(text);
  if (!Number.isFinite(amount)) return null;
  return Number(amount.toFixed(UF_MAX_DECIMALS));
}

/**
 * Formatea un monto UF para mostrarlo en el input con al menos
 * UF_MIN_DECIMALS y hasta UF_MAX_DECIMALS decimales (siempre con ".").
 * Ej: 1234 -> "1234.00", 1234.5 -> "1234.50", 1234.567 -> "1234.567".
 */
function formatUfForInput(value) {
  const amount = parseUfValue(value);
  if (amount === null) return null;

  const decimals = (String(amount).split(".")[1] || "").length;
  const visibleDecimals = Math.min(
    UF_MAX_DECIMALS,
    Math.max(UF_MIN_DECIMALS, decimals),
  );
  return amount.toFixed(visibleDecimals);
}

/**
 * Validador vuelidate para el monto UF: obligatorio y numérico con
 * hasta UF_MAX_DECIMALS decimales (acepta "," o "." como decimal).
 */
function decimalUf(value) {
  if (value === null || value === undefined || value === "") return true;
  return /^\d+([.,]\d{1,3})?$/.test(String(value).trim());
}

export default {
  components: { PreviewDocumentsSideASide },
  props: {
    modalAction: {
      type: Boolean,
      default: false,
    },
    closeModalCreateProjectFromPresale: {
      type: Function,
      default: () => {},
    },
    client: {
      default: null,
    },
    projectInfo: {
      default: null,
    },
    onlyRead: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      TYPE_CLIENT_COMPANY,
      TYPE_CLIENT_PERSON,
      loadingSearchClient: false,
      stepper: 1,
      disabledFormClient: true,
      clientSearchInSap: null,
      datepicker_menu_start: false,
      datepicker_menu_end: false,
      formClient: {
        type_client: TYPE_CLIENT_PERSON,
        rut: null,
        rutCompany: null,
        name: null,
        giro: null,
        contact_user_name: null,
        contact_user_email: null,
        contact_phone: null,
        commune: null,
        region: null,
        address: null,
      },
      form: {
        name_project: null,
        type_sale: null,
        uf_units: null,
        contract_date: null,
        csi_allowed: null,
        type_product: null,
      },
      csiAllowedOptions: [
        { text: "Sí, posee convenio bancario", value: true },
        { text: "No, no posee convenio bancario", value: false },
      ],
      submitUpload: false,
    };
  },
  validations() {
    return {
      formClient: {
        type_client: { required },
        rut: { required, rutValid },
        rutCompany:
          this.formClient.type_client === TYPE_CLIENT_COMPANY
            ? { required, rutValid }
            : {},
        name: { required },
        giro: { required },
        commune: {
          required,
        },
        contact_user_name: { required },
        contact_user_email: { required, email },
        contact_phone: { required },
        region: {
          required,
        },
        address: { required, maxLength: maxLength(50) },
      },
      form: {
        name_project: { required },
        type_sale: { required },
        uf_units: { required, decimalUf },
        contract_date: { required },
        csi_allowed: { required: requiredIf(function () { return !this.projectInfo; }) },
        type_product: { required },
      },
    };
  },
  async mounted() {
    if (!this.allRegions.length) {
      this.getRegions();
    }
    if (!this.allSupplierDrafts.length) {
      await this.getListOptionsSupplier();
    }
    setTimeout(() => {
      this.setDefaultGiro();
    }, 2000);

    await this.getTypeProjectProducts({
      is_residential: false,
      is_mobile: false,
    });

    if (this.$route.query.presale_code) {
      this.getTypeSales({
        preventa_id: this.$route.query.presale_code,
      });
    }
  },
  methods: {
    validateRut,
    validatePhone,
    ...mapActions({
      getListOptionsSupplier: "supplying/getListOptionsSupplier",
      getRegions: "common/getRegions",
      getTypeSales: "presale/getTypeSales",
      updateOrCreateProjectFromPresale:
        "presale/updateOrCreateProjectFromPresale",
      verifyExistClient: "presale/verifyExistClient",
      updateOrCreateClient: "presale/updateOrCreateClient",
      getTypeProjectProducts: "project/getTypeProjectProducts",
    }),
    setDefaultGiro() {
      if (this.formClient.type_client == TYPE_CLIENT_PERSON) {
        this.formClient.giro = this.allSupplierDrafts.find(
          (item) => item.name == BUSINESS_CATEGORY_PARTICULAR,
        )?.id;
      } else {
        this.formClient.giro = null;
      }
    },
    setClient(client) {
      this.formClient = {
        id: client.id ? client.id : null,
        type_client: client.company_rut
          ? TYPE_CLIENT_COMPANY
          : TYPE_CLIENT_PERSON,
        //Quitar la C al final solo si la tiene
        rut: client.rut.replace(/C$/, ""),
        rutCompany: client.company_rut
          ? client.company_rut.replace(/C$/, "")
          : null,
        name: client.official_name,
        giro: client.business_category
          ? client.business_category.id
          : this.formClient.type_client == TYPE_CLIENT_PERSON
          ? this.allSupplierDrafts.find(
              (item) => item.name == BUSINESS_CATEGORY_PARTICULAR,
            )?.id
          : null,
        contact_user_name: client.contact_user_name,
        contact_user_email: client.contact_user_email,
        contact_phone: client.contact_phone,
        region: client.region,
        commune: client.commune,
        address: client.address,
      };
    },
    formatRut() {
      this.formClient.rut = formatToChileanRut(this.formClient.rut);
    },
    formatRutCompany() {
      this.formClient.rutCompany = formatToChileanRut(
        this.formClient.rutCompany,
      );
    },
    // Permite sólo dígitos y los separadores "." o "," en el campo UF.
    // Se permite escribir el decimal como el usuario prefiera (punto o coma)
    // y la validación/parseo posterior se encarga de normalizarlo.
    onUfKeypress(event) {
      const { key, ctrlKey, metaKey, altKey } = event;
      if (ctrlKey || metaKey || altKey) return; // Atajos (copiar/pegar)
      if (key.length > 1) return; // Enter, Retroceso, flechas, Tab, etc.
      if (/^[0-9.,]$/.test(key)) return;
      event.preventDefault();
    },
    validateRutFormat(event) {
      const allowedCharacters = /[0-9.\-K]/i; // Permite números, punto, guión y "K" (mayúscula o minúscula)
      let textToValidate = event.key
        ? event.key
        : event.clipboardData.getData("text");

      if (!allowedCharacters.test(textToValidate)) {
        event.preventDefault();
      } else {
        if (!event.key) {
          this.formatRutCompany();
          this.formatRut();
        }
      }
    },
    async sendAddClient() {
      if (this.clientSearchInSap) {
        this.stepper = 2;
        if (!this.projectInfo) {
          this.setNameAndTypeProjectFromTypePresale();
        }
        return;
      }
      let self = this;
      self.submitUpload = true;
      if (!self.$v.formClient.$invalid) {
        if (!self.formClient.rut || !validateRut(self.formClient.rut)) {
          return self.$swal.fire({
            icon: "error",
            title: "Error",
            text: "El RUT debe tener un formato correcto",
            position: "top-end",
            showConfirmButton: false,
            toast: true,
            timer: 3000,
            timerProgressBar: true,
          });
        }
        self.loading = true;
        let payload = {
          id: self.client ? self.formClient.id : undefined,
          rut: self.formClient.rut,
          company_rut: self.formClient.rutCompany,
          name: self.formClient.name,
          official_name: self.formClient.name,
          business_category_uuid: self.formClient.giro,
          contact_user_name: self.formClient.contact_user_name,
          contact_user_email: self.formClient.contact_user_email,
          contact_phone: self.formClient.contact_phone
            ? self.formClient.contact_phone
            : undefined,
          region: self.formClient.region ? self.formClient.region : undefined,
          city: self.formClient.commune,
          commune: self.formClient.commune,
          address: self.formClient.address.replace(/[\r\n]/g, " "),
          user: self.user.email,
        };
        const resp = await self.updateOrCreateClient(payload);
        if (resp.status == 200) {
          if (!self.client) {
            self.clientSearchInSap = self.formClient;
          }
          swal2.fire({
            icon: "success",
            title: "Excelente",
            text: `Cliente ${
              self.client ? "modificado" : "agregado"
            } correctamente`,
            position: "top-end",
            showConfirmButton: false,
            toast: true,
            timer: 7000,
            timerProgressBar: true,
          });
          self.submitUpload = false;
          this.stepper = 2;
          if (!this.projectInfo) {
            this.setNameAndTypeProjectFromTypePresale();
          }
        }
        if (resp.status === 409 || resp.status === 404) {
          self.loading = false;
          return swal2.fire({
            icon: "error",
            title: "Error",
            text: resp.data.detail,
            position: "top-end",
            showConfirmButton: false,
            toast: true,
            timer: 5000,
            timerProgressBar: true,
          });
        }
        if (!resp.status || resp.status === 400) {
          self.loading = false;
          return swal2.fire({
            icon: "error",
            title: "Error",
            text: resp.data.detail,
            position: "top-end",
            showConfirmButton: false,
            toast: true,
            timer: 10000,
            timerProgressBar: true,
          });
        }
        this.loading = false;
      }
    },
    async searchClient(client_rut) {
      let self = this;
      self.loadingSearchClient = true;
      setTimeout(async function() {
        const resp = await self.verifyExistClient({
          code_filter:
            self.formClient.type_client !== TYPE_CLIENT_PERSON
              ? undefined
              : client_rut
              ? client_rut.replace(/C$/, "")
              : self.formClient.rut,
          company_code_filter:
            self.formClient.type_client !== TYPE_CLIENT_COMPANY
              ? undefined
              : client_rut
              ? client_rut.replace(/C$/, "")
              : self.formClient.rutCompany,
        });
        if (resp && !resp.items.length) {
          self.disabledFormClient = false;
          self.clientSearchInSap = null;
          self.$swal.fire({
            icon: "info",
            title: "Atención",
            text:
              "El RUT ingresado no existe, por favor ingresa los datos a continuación",
            position: "top-end",
            showConfirmButton: false,
            toast: true,
            timer: 7000,
            timerProgressBar: true,
          });
        }
        if (resp.items.length) {
          if (!self.client) {
            self.$swal.fire({
              icon: "success",
              title: "RUT encontrado, presiona continuar",
              position: "top-end",
              showConfirmButton: false,
              toast: true,
              timer: 3000,
              timerProgressBar: true,
            });
            self.clientSearchInSap = resp.items[0];
            self.disabledFormClient = true;
          } else {
            self.disabledFormClient = false;
          }
          self.setClient(resp.items[0]);
        }
        self.loadingSearchClient = false;
      }, 2000);
    },
    async sendCreateProjectFromPresale() {
      let self = this;
      self.submitUpload = true;
      if (!self.$v.form.$invalid) {
        self.loading = true;
        let payload = {
          id: self.projectInfo ? self.projectInfo.id : undefined,
          project_name: self.form.name_project,
          pre_project_id: self.$route.query.presale_code,
          user: self.user.email,
          selltype: self.form.type_sale,
          client_rut: self.formClient.rut.replaceAll("C", ""),
          price: parseUfValue(self.form.uf_units),
          doc_date: `${self.form.contract_date} 00:00:00`,
          csiAllowed: self.csiAllowedValue,
          //CAMPO NUEVO DE TIPO DE PRODUCTO
          parent_project_code: self.form.type_product,
          empresa_rut: self.formClient.rutCompany
            ? self.formClient.rutCompany.replaceAll("C", "")
            : null,
          user: self.user.email,
        };
        const resp = await self.updateOrCreateProjectFromPresale(payload);
        if (resp.status == 200) {
          swal2.fire({
            icon: "success",
            title: "Excelente",
            text: `Información de Preventa: ${self.form.name_project} ${
              self.projectInfo
                ? "modificada correctamente, vuelve al listado de preventas para marcar la preventa como Revisada"
                : "agregada correctamente, sera revisada por el Control de Gestión para su aprobación"
            }`,
            position: "top-end",
            showConfirmButton: false,
            toast: true,
            timer: 9000,
            timerProgressBar: true,
          });
          if (!self.projectInfo) {
            this.$emit("projectCreated");
          }
          this.closeModalCreateProjectFromPresale(true);
          this.resetForm();
        }
        if (resp.status === 409 || resp.status === 404) {
          self.loading = false;
          return swal2.fire({
            icon: "error",
            title: "Error",
            text: resp.data.detail,
            position: "top-end",
            showConfirmButton: false,
            toast: true,
            timer: 5000,
            timerProgressBar: true,
          });
        }
        if (resp && resp.status === 400) {
          self.loading = false;
          return swal2.fire({
            icon: "error",
            title: "Error",
            text: resp.data.detail,
            position: "top-end",
            showConfirmButton: false,
            toast: true,
            timer: 10000,
            timerProgressBar: true,
          });
        }
        if (!resp.status || resp.status === 500) {
          self.loading = false;
          return swal2.fire({
            icon: "error",
            title: "Error",
            text: "Ha ocurrido un error en el servidor, intentalo nuevamente",
            position: "top-end",
            showConfirmButton: false,
            toast: true,
            timer: 10000,
            timerProgressBar: true,
          });
        }
        this.loading = false;
      }
    },
    executeCloseModalCreateProjectFromPresale($event) {
      let validationEvent = preventCloseIfNotKeyEventEsc($event);
      if (validationEvent) {
        if (!this.client) {
          this.resetForm();
        }
        this.closeModalCreateProjectFromPresale($event);
      }
    },
    resetForm() {
      this.formClient = {
        type_client: TYPE_CLIENT_PERSON,
        rut: null,
        rutCompany: null,
        name: null,
        giro: null,
        contact_user_name: null,
        contact_user_email: null,
        contact_phone: null,
        region: null,
        commune: null,
        address: null,
      };
      this.form = {
        name_project: null,
        type_sale: null,
        uf_units: null,
        contract_date: null,
        csi_allowed: null,
        type_product: null,
      };
      this.clientSearchInSap = null;
      this.disabledFormClient = true;
      this.stepper = 1;
      this.submitUpload = false;
      this.setDefaultGiro();
    },
    setNameAndTypeProjectFromTypePresale() {
      this.form.type_sale = this.$route.query.presale_type;
      this.form.name_project =
        this.form.type_sale == TYPE_PROJECTS_RESIDENTIAL[0].id
          ? `PR IND ${this.formClient.contact_user_name}`
          : null;
    },
    setDocumentsToCompare(documentsToCompare) {
      this.$refs.previewDocumentsSideAside.setDocumentsToCompare(
        documentsToCompare,
      );
    },
    setTypeClientCompany() {
      this.formClient.type_client = TYPE_CLIENT_COMPANY;
    },
    normalizeCsiAllowedText(text) {
      return String(text)
        .trim()
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");
    },
    onChangeCsiAllowed(value) {
      if (value !== null && typeof value === "object") {
        return;
      }
      if (value === null || value === undefined || value === "") {
        this.form.csi_allowed = null;
        return;
      }
      const search = this.normalizeCsiAllowedText(value);
      const option = search
        ? this.csiAllowedOptions.find((item) =>
            this.normalizeCsiAllowedText(item.text).startsWith(search),
          )
        : null;
      this.form.csi_allowed = option || null;
    },
  },
  computed: {
    ...authUsuarioComputed,
    ...mapGetters({
      allSupplierDrafts: "supplying/allSupplierDrafts",
      typeSales: "presale/typeSales",
      allRegions: "common/allRegions",
      documents: "document/documents",
      typeProjectProducts: "project/typeProjectProducts",
    }),
    wrappedTypeProjectProducts() {
      return this.typeProjectProducts.map((item) => {
        return {
          ...item,
          name_code: `${item.code} - ${item.name}`,
        };
      });
    },
    wrappedRegions() {
      return this.allRegions.map((item) => item.region);
    },
    communes() {
      let comunnes = [];
      this.allRegions.forEach((item) => {
        if (Array.isArray(item.comunas)) {
          item.comunas.forEach((commune) => {
            comunnes.push({
              name: commune,
              region: item.region,
            });
          });
        }
      });
      return comunnes.sort((a, b) => a.name.localeCompare(b.name));
    },
    wrappedAllSupplierDrafts() {
      if (this.formClient.type_client == TYPE_CLIENT_COMPANY) {
        return this.allSupplierDrafts.filter(
          (item) => item.name != BUSINESS_CATEGORY_PARTICULAR,
        );
      } else {
        return this.allSupplierDrafts;
      }
    },
    // Mensaje de error del campo UF: distingue requerido vs formato
    ufErrorMessage() {
      if (!this.$v.form.uf_units.required) {
        return "Este campo es requerido";
      }
      return `Ingresa un monto numérico con hasta ${UF_MAX_DECIMALS} decimales (ej: 1234.50)`;
    },
    // Monto UF formateado con decimales en formato chileno (ej: 1.234,56)
    ufDisplayValue() {
      const amount = parseUfValue(this.form.uf_units);
      if (amount === null) return "";
      return new Intl.NumberFormat("es-CL", {
        minimumFractionDigits: UF_MIN_DECIMALS,
        maximumFractionDigits: UF_MAX_DECIMALS,
      }).format(amount);
    },
    csiAllowedValue() {
      const value = this.form.csi_allowed;
      if (value === null || value === undefined || value === "") {
        return false;
      }
      if (typeof value === "object") {
        return value.value === true;
      }
      if (typeof value === "boolean") {
        return value;
      }
      const option = this.csiAllowedOptions.find(
        (item) =>
          this.normalizeCsiAllowedText(item.text) ===
          this.normalizeCsiAllowedText(value),
      );
      return option ? option.value === true : false;
    },
    documentsContractAndIdentityCard() {
      return this.documents.length
        ? this.documents[0].children
            .find((folder) => folder.name == NAME_FOLDER_SALE_RESIDENTIAL)
            .folder_document_types.filter(
              (document_type) =>
                (document_type.document_type.name == NAME_FILE_CONTRACT ||
                  document_type.document_type.name ==
                    NAME_FILE_IDENTITY_CARD) &&
                document_type.documents.length,
            )
        : [];
    },
    contract_date_formatted() {
      if (this.form.contract_date) {
        return moment(this.form.contract_date).format("DD/MM/YYYY");
      }
      return null;
    },
    //Validación de la fecha de contrato,
    //Solo puedes elegir una fecha anterior o igual a hoy,
    //pero desde las 00:00hrs hasta las 07:00hrs (Hora de Chile) no puede seleccionar el día de hoy (solo de ayer hacia atras).
    maxContractDate() {
      const chileTimeZone = "America/Santiago";
      const now = new Date(); // Obtiene el timestamp actual
      // --- 1. Obtener la HORA actual en Chile ---
      // Usamos 'en-US' como locale base solo para parsear la hora.
      // 'hourCycle: h23' nos da la hora en formato 00-23.
      const hourFormatter = new Intl.DateTimeFormat("en-US", {
        timeZone: chileTimeZone,
        hour: "2-digit",
        hourCycle: "h23",
      });
      const currentHourInChile = parseInt(hourFormatter.format(now), 10);
      // --- 2. Definir el formateador de FECHA (YYYY-MM-DD) ---
      // 'en-CA' convenientemente usa el formato YYYY-MM-DD
      const dateFormatter = new Intl.DateTimeFormat("en-CA", {
        timeZone: chileTimeZone,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });

      // --- 3. Aplicar la lógica ---
      if (currentHourInChile >= 0 && currentHourInChile < 7) {
        // Entre 00:00 y 06:59 -> Max es AYER
        // Calculamos el timestamp de hace 24 horas
        const yesterdayTimestamp = now.getTime() - 24 * 60 * 60 * 1000;
        return dateFormatter.format(yesterdayTimestamp);
      } else {
        // 07:00 en adelante -> Max es HOY
        return dateFormatter.format(now);
      }
    },
  },
  watch: {
    client(client) {
      if (client) {
        this.searchClient(client);
      }
    },
    projectInfo: function(projectInfo) {
      if (projectInfo) {
        const projectId = projectInfo.id ?? null;
        const isSameProject =
          projectId !== null && projectId === this._lastAppliedProjectId;
        const isCleanCsi = this.form.csi_allowed === null;
        this.form.name_project = projectInfo.project_name;
        this.form.type_sale = projectInfo.selltype;
        // Se formatea para mostrar siempre el monto con decimales
        this.form.uf_units = formatUfForInput(projectInfo.price);
        this.form.type_product = projectInfo.parent_project_code;
        this.form.contract_date = projectInfo.doc_date
          ? moment(projectInfo.doc_date).format("YYYY-MM-DD")
          : null;
        if (!isSameProject || isCleanCsi) {
          const csiAllowed =
            projectInfo.csiAllowed ?? projectInfo.csi_allowed ?? false;
          this.form.csi_allowed = this.csiAllowedOptions.find(
            (option) => option.value === Boolean(csiAllowed),
          );
        }
        this._lastAppliedProjectId = projectId;
      }
    },
    "form.csi_allowed": function(value) {
      if (typeof value === "string") {
        const option = this.csiAllowedOptions.find(
          (item) =>
            this.normalizeCsiAllowedText(item.text) ===
            this.normalizeCsiAllowedText(value),
        );
        this.form.csi_allowed = option || null;
      }
    },
    "formClient.type_client": function(newValue) {
      if (newValue == TYPE_CLIENT_PERSON) {
        this.formClient.giro = this.allSupplierDrafts.find(
          (item) => item.name == BUSINESS_CATEGORY_PARTICULAR,
        )?.id;
        this.formClient.rutCompany = null;
      } else {
        if (
          this.formClient.giro &&
          this.allSupplierDrafts.find((item) => item.id == this.formClient.giro)
            .name == BUSINESS_CATEGORY_PARTICULAR
        ) {
          this.formClient.giro = null;
        }
      }
    },
    "formClient.name": function(newValue) {
      if (this.formClient.type_client == TYPE_CLIENT_PERSON) {
        this.formClient.contact_user_name = newValue;
      }
    },
    "formClient.commune": function(newValue) {
      if (newValue) {
        let commune = this.communes.find((item) => item.name === newValue);
        this.formClient.region = this.allRegions.find(
          (item) => item.region === commune.region,
        ).region;
      } else {
        this.form.region = null;
      }
    },
  },
};
</script>

<style></style>